/// <reference path="../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../node_modules/@types/jquery.validation/index.d.ts" />

import { DropdownListUtility } from "./DropdownListUtility";
export class ProgramServiceAccount {

    //Init is called during page handler setup.
    //Bind Required Fields will be called after page handler setup and may override some of readonly settings.
    public static Init() {

        var accountNumberMask: string = $("#SiteConfigOptions_AccountNumberMask").val() as string;
        var accountPlaceholder: string = "_".repeat(accountNumberMask.length);

        const match = accountNumberMask.match(/^0+/);
        const accountNumberLeadingZeros = match ? match[0].length : 0;

        var meterNumberMask: string = $("#SiteConfigOptions_MeterNumberMask").val() as string;
        var meterPlaceholder: string = "_".repeat(meterNumberMask.length);

        if ($("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber").length) {
            (<any>$("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber")).mask(accountNumberMask, { clearIfNotMatch: true, placeholder: accountPlaceholder });
            $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber").prop("maxlength", accountNumberMask.length);
        }

        if ($("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked").length) {
            $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked").prop("maxlength", accountNumberMask.length);
            $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked").attr("minlength", accountNumberLeadingZeros);
        }

        if ($("#ApplicationInformation_ServiceAccountInformation_GasAccountNumber").length) {
            (<any>$("#ApplicationInformation_ServiceAccountInformation_GasAccountNumber")).mask(accountNumberMask, { clearIfNotMatch: true, placeholder: accountPlaceholder });
            $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumber").prop("maxlength", accountNumberMask.length);
        }

        if ($("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked").length) {
            $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked").prop("maxlength", accountNumberMask.length);
            $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked").attr("minlength", accountNumberLeadingZeros);
        }

        if ($("#ApplicationInformation_ServiceAccountInformation_ElectricMeterNumber").length) {
            (<any>$("#ApplicationInformation_ServiceAccountInformation_ElectricMeterNumber")).mask(meterNumberMask, { clearIfNotMatch: true, placeholder: meterPlaceholder, translation: { A: { pattern: /A/, fallback: 'A', optional: false } } });
            $("#ApplicationInformation_ServiceAccountInformation_ElectricMeterNumber").prop("maxlength", meterNumberMask.length);
        }

        if ($("#ApplicationInformation_ServiceAccountInformation_GasMeterNumber").length) {
            (<any>$("#ApplicationInformation_ServiceAccountInformation_GasMeterNumber")).mask(meterNumberMask, { clearIfNotMatch: true, placeholder: meterPlaceholder, translation: { A: { pattern: /A/, fallback: 'A', optional: false } } });
            $("#ApplicationInformation_ServiceAccountInformation_GasMeterNumber").prop("maxlength", meterNumberMask.length);
        }

        DropdownListUtility.PrePopulateDropDownOption('#ApplicationInformation_ServiceAccountInformation_ElectricUtilityProviderId', this.OnSelectEletricUtilityProviders);
        DropdownListUtility.PrePopulateDropDownOption('#ApplicationInformation_ServiceAccountInformation_GasUtilityProviderId', this.OnSelectGasUtilityProviders);
        if ($('#ApplicationInformation_ServiceAccountInformation_ElectricUtilityProviderId').length) {
            $('#ApplicationInformation_ServiceAccountInformation_ElectricUtilityProviderId').on("change", () => {

                this.OnSelectEletricUtilityProviders();
                $('#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber').val("");
            });
        }

        if ($('#ApplicationInformation_ServiceAccountInformation_GasUtilityProviderId').length) {
            $('#ApplicationInformation_ServiceAccountInformation_GasUtilityProviderId').on("change", () => {

                this.OnSelectGasUtilityProviders();
                $('#ApplicationInformation_ServiceAccountInformation_GasAccountNumber').val("");
            });
        }

        //Sets the default state if the checkbox is checked on load (see comment above)
        if ($('#ApplicationInformation_ServiceAccountInformation_HasElectricServiceAccount').length && $('#ApplicationInformation_ServiceAccountInformation_HasElectricServiceAccount').is(':checked')) {
            $("#ApplicationInformation_ServiceAccountInformation_ElectricMeterNumber").prop('disabled', false).prop('readonly', false);
            $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber").prop('disabled', false).prop('readonly', false);
            $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked").prop('disabled', false).prop('readonly', false);
            $("#ApplicationInformation_ServiceAccountInformation_ElectricUtilityProviderId").prop('disabled', false).prop('readonly', false);
        }

        //Sets the default state if the checkbox is checked on load (see comment above)
        if ($('#ApplicationInformation_ServiceAccountInformation_HasGasServiceAccount').length && $('#ApplicationInformation_ServiceAccountInformation_HasGasServiceAccount').is(':checked')) {
            $("#ApplicationInformation_ServiceAccountInformation_GasMeterNumber").prop('disabled', false).prop('readonly', false);
            $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumber").prop('disabled', false).prop('readonly', false);
            $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked").prop('disabled', false).prop('readonly', false);
            $("#ApplicationInformation_ServiceAccountInformation_GasUtilityProviderId").prop('disabled', false).prop('readonly', false);
        }

        //Toggles editablity of account number fields based on checkbox state
        if ($("#ApplicationInformation_ServiceAccountInformation_HasElectricServiceAccount").length) {
            $("#ApplicationInformation_ServiceAccountInformation_HasElectricServiceAccount").on("change_acct:custom", function(e, options) {
                $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber").prop('readonly', options.disabled);
                if (options.disabled) {
                    $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber").val("");
                }
                $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked").prop('readonly', options.disabled);
                if (options.disabled) {
                    $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked").val("");
                }
            });
        }

        //Toggles editablity of account number fields based on checkbox state
        if ($("#ApplicationInformation_ServiceAccountInformation_HasGasServiceAccount").length) {
            $("#ApplicationInformation_ServiceAccountInformation_HasGasServiceAccount").on("change_acct:custom", function(e, options) {
                $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumber").prop('readonly', options.disabled);
                if (options.disabled) {
                    $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumber").val("");
                }
                $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked").prop('readonly', options.disabled);
                if (options.disabled) {
                    $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked").val("");
                }
            });
        }

        if ($("#ApplicationInformation_ServiceAccountInformation_ComboAccountNumber").length) {
            (<any>$("#ApplicationInformation_ServiceAccountInformation_ComboAccountNumber")).mask(accountNumberMask, { clearIfNotMatch: true, placeholder: accountPlaceholder });
            $("#ApplicationInformation_ServiceAccountInformation_ComboAccountNumber").prop("maxlength", accountNumberMask.length);
        }

    }

    ///Called after Required Fields are loaded and bound.
    public static InitProgramServiceAccountFields() {

        var programServiceAccountTypeId: string = $('#ApplicationInformation_ServiceAccountInformation_ProgramServiceAccountTypeId').val() as string;

        switch (programServiceAccountTypeId) {

            case "ElectricOnly":
            case "GasOnly":
            case "CommonGasElectric":
            case "CommonElectricGas":
                ProgramServiceAccount.InitGasServiceAccountNoneFields();
                ProgramServiceAccount.InitElectricServiceAccountNoneFields();
                break;

            case "SingleAccountComboUtility":
                ProgramServiceAccount.InitComboServiceAccountNoneFields();
                break;

            case "CommonGasElectricServiceOptionSelect":
            case "CommonGasElectricServiceOptionSelectRequired":
            case "CommonElectricGasServiceOptionSelect":
            case "CommonElectricGasServiceOptionSelectRequired":
                ProgramServiceAccount.InitServiceAccountFields();
                ProgramServiceAccount.BindDefaultServiceAccountHandlers();
                break;

            case "SingleAccountComboUtility":
                break;

            default:
            //noop
        }
    }


    private static OnSelectEletricUtilityProviders() {   
            var electricOpt = $('#ApplicationInformation_ServiceAccountInformation_ElectricUtilityProviderId option:selected').data("code-type");
            if (electricOpt == 'AccountNumberNotRequired') {
                $('#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber').prop('readonly', true);
                $('#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber').rules("remove", "required");
            } else if (electricOpt == 'AccountNumberOptional') {
                $('#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber').prop('readonly', false);
                $('#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber').rules("remove", "required");
            } else {
                $('#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber').prop('readonly', false);
                $('#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber').rules("add", {
                    required: true,
                    messages: {
                        required: "Required"
                    }
                });
            }
    }

    private static OnSelectGasUtilityProviders() {
            var gasOpt = $('#ApplicationInformation_ServiceAccountInformation_GasUtilityProviderId option:selected').data("code-type");
            if (gasOpt == 'AccountNumberNotRequired') {
                $('#ApplicationInformation_ServiceAccountInformation_GasAccountNumber').prop('readonly', true);
                $('#ApplicationInformation_ServiceAccountInformation_GasAccountNumber').rules("remove", "required");
            } else if (gasOpt == 'AccountNumberOptional') {
                $('#ApplicationInformation_ServiceAccountInformation_GasAccountNumber').prop('readonly', false);
                $('#ApplicationInformation_ServiceAccountInformation_GasAccountNumber').rules("remove", "required");
            } else {
                $('#ApplicationInformation_ServiceAccountInformation_GasAccountNumber').prop('readonly', false);
                $('#ApplicationInformation_ServiceAccountInformation_GasAccountNumber').rules("add", {
                    required: true,
                    messages: {
                        required: "Required"
                    }
                });
            }
    }

    private static InitGasServiceAccountNoneFields() {
        if ($("#ApplicationInformation_ServiceAccountInformation_GasUtilityProviderId").is(":visible") && $('#ApplicationInformation_ServiceAccountInformation_GasUtilityProviderId option:selected').data("code-type")) {
            var gasOpt = $('#ApplicationInformation_ServiceAccountInformation_GasUtilityProviderId option:selected').data("code-type");
            if (gasOpt == 'AccountNumberNotRequired') {
                $('#ApplicationInformation_ServiceAccountInformation_GasAccountNumber').prop('readonly', true);
                $('#ApplicationInformation_ServiceAccountInformation_GasAccountNumber').rules("remove", "required");
            } else if (gasOpt == 'AccountNumberOptional') {
                $('#ApplicationInformation_ServiceAccountInformation_GasAccountNumber').rules("remove", "required");
            }
        }

        var skip = $("#SkipValidation").val();
        var accountNumberMask: string = $("#SiteConfigOptions_AccountNumberMask").val() as string;
        var accountPlaceholder: string = "_".repeat(accountNumberMask.length);

        if ($("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked").is(":visible") && skip == "True") {
            (<any>$("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked")).mask(accountNumberMask, { clearIfNotMatch: true, placeholder: accountPlaceholder });
        }
    }

    private static InitElectricServiceAccountNoneFields() {
        if ($("#ApplicationInformation_ServiceAccountInformation_ElectricUtilityProviderId").is(":visible") && $('#ApplicationInformation_ServiceAccountInformation_ElectricUtilityProviderId option:selected').data("code-type")) {
            var electricOpt = $('#ApplicationInformation_ServiceAccountInformation_ElectricUtilityProviderId option:selected').data("code-type");
            if (electricOpt == 'AccountNumberNotRequired') {
                $('#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber').prop('readonly', true);
                $('#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber').rules("remove", "required");
            } else if (electricOpt == 'AccountNumberOptional') {
                $('#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber').rules("remove", "required");
            }
        }

        var skip = $("#SkipValidation").val();
        var accountNumberMask: string = $("#SiteConfigOptions_AccountNumberMask").val() as string;
        var accountPlaceholder: string = "_".repeat(accountNumberMask.length);

        if ($("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked").is(":visible") && skip == "True") {
            (<any>$("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked")).mask(accountNumberMask, { clearIfNotMatch: true, placeholder: accountPlaceholder });
        }
    }

    private static InitComboServiceAccountNoneFields() {
        var skip = $("#SkipValidation").val();
        var accountNumberMask: string = $("#SiteConfigOptions_AccountNumberMask").val() as string;
        var accountPlaceholder: string = "_".repeat(accountNumberMask.length);

        if ($("#ApplicationInformation_ServiceAccountInformation_ComboAccountNumberMasked").is(":visible") && skip == "True") {
            (<any>$("#ApplicationInformation_ServiceAccountInformation_ComboAccountNumberMasked")).mask(accountNumberMask, { clearIfNotMatch: true, placeholder: accountPlaceholder });
        }
    }

    private static BindDefaultServiceAccountHandlers() {

        var accountNumberMask: string = $("#SiteConfigOptions_AccountNumberMask").val() as string;
        var accountPlaceholder: string = "_".repeat(accountNumberMask.length);

        $('#ApplicationInformation_ServiceAccountInformation_HasElectricServiceAccount').on("click", (e: JQuery.ClickEvent) => {

            $("#ApplicationInformation_ServiceAccountInformation_ElectricMeterNumber").prop('readonly', !e.currentTarget.checked);
            $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber").prop('readonly', !e.currentTarget.checked);
            $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked").prop('readonly', !e.currentTarget.checked);

            if (!e.currentTarget.checked) {

                $("#ApplicationInformation_ServiceAccountInformation_ElectricMeterNumber").val("");
                $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber").val("");
                $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked").val("");
            } else {
                (<any>$("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked")).mask(accountNumberMask, { clearIfNotMatch: true, placeholder: accountPlaceholder });
            }
            $("#ApplicationInformation_ServiceAccountInformation_ElectricUtilityProviderId").prop('disabled', !e.currentTarget.checked);
            if (!e.currentTarget.checked) {
                $("#ApplicationInformation_ServiceAccountInformation_ElectricUtilityProviderId").prop('selectedIndex', 0);
            }
            $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked").valid();
        });

        $('#ApplicationInformation_ServiceAccountInformation_HasGasServiceAccount').on('click', (e: JQuery.ClickEvent) => {
            $("#ApplicationInformation_ServiceAccountInformation_GasMeterNumber").prop('readonly', !e.currentTarget.checked);
            $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumber").prop('readonly', !e.currentTarget.checked);
            $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked").prop('readonly', !e.currentTarget.checked);

            if (!e.currentTarget.checked) {
                $("#ApplicationInformation_ServiceAccountInformation_GasMeterNumber").val("");
                $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumber").val("");
                $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked").val("");
            } else {
                (<any>$("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked")).mask(accountNumberMask, { clearIfNotMatch: true, placeholder: accountPlaceholder });
            }
            $("#ApplicationInformation_ServiceAccountInformation_GasUtilityProviderId").prop('disabled', !e.currentTarget.checked);
            if (!e.currentTarget.checked) {
                $("#ApplicationInformation_ServiceAccountInformation_GasUtilityProviderId").prop('selectedIndex', 0);
            }
            $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked").valid();
        });

        $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked").rules("add", {
            requiredIfChecked: "#ApplicationInformation_ServiceAccountInformation_HasGasServiceAccount",
            messages: {
                requiredIfChecked: "Please enter your gas account number if you have gas service."
            }
        });

        $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked").rules("add", {
            requiredIfChecked: "#ApplicationInformation_ServiceAccountInformation_HasElectricServiceAccount",
            messages: {
                requiredIfChecked: "Please enter your electric account number if you have electric service."
            }
        });

    }

    private static InitServiceAccountFields() {

        if ($('#ApplicationInformation_ServiceAccountInformation_HasElectricServiceAccount').is(':checked') &&
            $('#ApplicationInformation_ServiceAccountInformation_HasElectricServiceAccount').is(':not([readonly])')) {
            $("#ApplicationInformation_ServiceAccountInformation_ElectricMeterNumber").prop('disabled', false).prop('readonly', false);
            $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber").prop('disabled', false).prop('readonly', false);
            $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked").prop('disabled', false).prop('readonly', false);
            $("#ApplicationInformation_ServiceAccountInformation_ElectricUtilityProviderId").prop('disabled', false).prop('readonly', false);
        } else {
            $("#ApplicationInformation_ServiceAccountInformation_ElectricMeterNumber").prop('readonly', true);
            $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumber").prop('readonly', true);
            $("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked").prop('readonly', true);
            $("#ApplicationInformation_ServiceAccountInformation_ElectricUtilityProviderId").prop('disabled', true).prop('readonly', true);
        }

        if ($('#ApplicationInformation_ServiceAccountInformation_HasGasServiceAccount').is(':checked') &&
            $('#ApplicationInformation_ServiceAccountInformation_HasGasServiceAccount').is(':not([readonly])')) {
            $("#ApplicationInformation_ServiceAccountInformation_GasMeterNumber").prop('disabled', false).prop('readonly', false);
            $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumber").prop('disabled', false).prop('readonly', false);
            $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked").prop('disabled', false).prop('readonly', false);
            $("#ApplicationInformation_ServiceAccountInformation_GasUtilityProviderId").prop('disabled', false).prop('readonly', false);
        } else {
            $("#ApplicationInformation_ServiceAccountInformation_GasMeterNumber").prop('readonly', true);
            $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumber").prop('readonly', true);
            $("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked").prop('readonly', true);
            $("#ApplicationInformation_ServiceAccountInformation_GasUtilityProviderId").prop('disabled', true).prop('readonly', true);

        }

        var skip = $("#SkipValidation").val();
        var accountNumberMask: string = $("#SiteConfigOptions_AccountNumberMask").val() as string;
        var accountPlaceholder: string = "_".repeat(accountNumberMask.length);

        if ($("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked").is(":visible") && skip == "True") {
            (<any>$("#ApplicationInformation_ServiceAccountInformation_ElectricAccountNumberMasked")).mask(accountNumberMask, { clearIfNotMatch: true, placeholder: accountPlaceholder });
        }

        if ($("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked").is(":visible") && skip == "True") {
            (<any>$("#ApplicationInformation_ServiceAccountInformation_GasAccountNumberMasked")).mask(accountNumberMask, { clearIfNotMatch: true, placeholder: accountPlaceholder });
        }

    }

}
